import { useCallback, useEffect, useState } from 'react'

import AudioEngine from '@/webgl/audio/AudioEngine'
import { SubtitleEvent } from '@/webgl/audio/SubtitleLibrary'
import SubtitleTrack, { Subtitle } from '@/webgl/audio/SubtitleTrack'

export default function useAudioSubtitle() {
  const [current, setCurrent] = useState<Subtitle | null>(null)
  const [track, setTrack] = useState<SubtitleTrack | null>(null)

  const trackUpdate = useCallback((e: SubtitleEvent) => {
    setCurrent(e.track?.getSubtitleAt(e.time) ?? null)
  }, [])

  const trackChange = useCallback((e: SubtitleEvent) => {
    setTrack(e.track)
    setCurrent(e.track?.getSubtitleAt(e.time) ?? null)
  }, [])

  useEffect(() => {
    const sub = AudioEngine.instance.subtitles

    sub.onTrackUpdate.on(trackUpdate)
    sub.onTrackChange.on(trackChange)

    return () => {
      sub.onTrackChange.off(trackChange)
    }
  }, [trackUpdate, trackChange])

  return { current, track }
}
